import { Injectable } from '@angular/core';
import { ApiServiceService } from '../../../services/api-service.service';
import { BehaviorSubject, catchError, throwError } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { formatParams } from '../../../helpers/FormateArrayToParams';

@Injectable({
  providedIn: 'root'
})
export class VendorsService {

  refreshList = new BehaviorSubject<boolean>(false);

  constructor(private apiService: ApiServiceService) { }

  GetCities_Filter(model: any) {
    return this.apiService.get(`${environment.apiUrl}/cities`, model)
      .pipe(catchError(this.handleError));
  }

  GetCategories_Filter(model: any) {
    return this.apiService.get(`${environment.apiUrl}/categories/list`, model)
      .pipe(catchError(this.handleError));
  }

  GetCategoriesWithSubcategory() {
    return this.apiService.get(`${environment.apiUrl}/categories-with-children`)
      .pipe(catchError(this.handleError));
  }

  GetCategoriesWithSubcategory_vendorID(id: string) {
    return this.apiService.get(`${environment.apiUrl}/categories-with-children-by-vendor/${id}`)
      .pipe(catchError(this.handleError));
  }

  // Vendor Actions [Start]
  GetVendors(model: any) {
    let params = formatParams(model)
    return this.apiService.get(`${environment.apiUrl}/vendors${params}`)
      .pipe(catchError(this.handleError));
  }
  AddVendor(model: any) {
    return this.apiService.post(`${environment.apiUrl}/vendors`, model)
      .pipe(catchError(this.handleError));
  }

  UpdateVendor(model: any, id: string) {
    return this.apiService.post(`${environment.apiUrl}/vendors/${id}`, model)
      .pipe(catchError(this.handleError));
  }

  SuspendVendor(id: string) {
    return this.apiService.post(`${environment.apiUrl}/vendors/suspend/${id}`)
      .pipe(catchError(this.handleError));
  }

  UnsuspendVendor(id: string) {
    return this.apiService.post(`${environment.apiUrl}/vendors/unsuspend/${id}`)
      .pipe(catchError(this.handleError));
  }

  DeleteVendor(id: string) {
    return this.apiService.remove(`${environment.apiUrl}/vendors/${id}`)
      .pipe(catchError(this.handleError));
  }

  ResendVerificationVendor(id: string) {
    return this.apiService.post(`${environment.apiUrl}/resend-verification-vendor/${id}`)
      .pipe(catchError(this.handleError));
  }

  GetVendorBranches(model: any) {
    return this.apiService.get(`${environment.apiUrl}/vendors/vendor-branches`, model)
      .pipe(catchError(this.handleError));
  }
  // Vendor Actions [End]



  // Vendor registration requests [Start]
  GetVendorRequestsList(model: any) {
    let Params = formatParams(model)
    return this.apiService.get(`${environment.apiUrl}/vendors-registration-request${Params}`)
      .pipe(catchError(this.handleError));
  }

  GetVendorRequestDetails(id: string) {
    return this.apiService.post(`${environment.apiUrl}/vendors-registration-request/request-details/?request_id=${id}`)
      .pipe(catchError(this.handleError));
  }

  GetVendorSub_Category(model: any) {
    return this.apiService.post(`${environment.apiUrl}/vendors-registration-request/vendor-sub-category`, model)
      .pipe(catchError(this.handleError));
  }

  ApproveVendorRequest(model: any) {
    return this.apiService.post(`${environment.apiUrl}/vendors-registration-request/approve-request`, model)
      .pipe(catchError(this.handleError));
  }

  DeclineVendorRequest(model: any) {
    return this.apiService.post(`${environment.apiUrl}/vendors-registration-request/reject-request`, model)
      .pipe(catchError(this.handleError));
  }

  VendorProfile(id: string) {
    return this.apiService.get(`${environment.apiUrl}/vendors/profile/?vendor_id=${id}`)
      .pipe(catchError(this.handleError));
  }
  // Vendor registration requests [End]




  // Vendor Withdrawal requests [Start]

  GetVendorWithdrawalRequestsList(model: any) {
    return this.apiService.get(`${environment.apiUrl}/vendors-money-withdraw-request`, model)
      .pipe(catchError(this.handleError));
  }

  GetVendorWithdrawalRequestDetails(id: string) {
    return this.apiService.post(`${environment.apiUrl}/vendors-money-withdraw-request/request-details/?request_id=${id}`)
      .pipe(catchError(this.handleError));
  }

  ApproveVendorWithdrawalRequest(model: any) {
    return this.apiService.post(`${environment.apiUrl}/vendors-money-withdraw-request/approve-request`, model)
      .pipe(catchError(this.handleError));
  }

  DeclineVendorWithdrawalRequest(model: any) {
    return this.apiService.post(`${environment.apiUrl}/vendors-money-withdraw-request/reject-request`, model)
      .pipe(catchError(this.handleError));
  }

  // Vendor Withdrawal requests [End]


  GetRedeemedPoints(model: any) {
    return this.apiService.get(`${environment.apiUrl}/vendors-redeemed-points`, model)
      .pipe(catchError(this.handleError));
  }


  SearchInMap(searchText: string) {
    let model: any = {
      format: 'jsonv2',
      countrycodes: "SA",
      limit: 10,
      q: searchText
    }
    return this.apiService.get(`https://nominatim.openstreetmap.org/search.php`, model)
      .pipe(catchError(this.handleError));
  }

  handleError(error: any) {
    return throwError(error);
  }
}
